export default {
  "b2b.zakaznici-grid-columns.adresa.label": "Address",
  "b2b.zakaznici-grid-columns.ico.label": "CIN",
  "b2b.zakaznici-grid-columns.nazev.label": "Name"
};
